/** When given an HTMLElement, this cause a 'reflow' so that its layout is calculated by the browser. This causes the
 * browser to know the element's location for when the subsequent code changes the elements layout, and allows a CSS
 * transition to run. If a 'reflow' does not happen and the same CSS property is changed then the transition will not
 * occur
 */
export function prepareForTransition(htmlElement: HTMLElement) {
  // Call the scrollHeight getter on the element to ensure a reflow has happened, then discard the value using "void".
  void htmlElement.scrollHeight;
}